import React from "react";
import { PythonService } from "../../api/python";
import ExcelUploadPanel from "./ExcelUploadPanel";

const COUNTERS_HELP = `Formato del Excel:
- Fila 1: encabezado (ej. student_id)
- Fila 2 en adelante: un ID por fila en columna A`;

const InitializeCounters = () => (
  <ExcelUploadPanel
    title="Inicializar contadores"
    description="Crea registros en counters (en 0) para estudiantes que aún no los tienen."
    helpText={COUNTERS_HELP}
    submitLabel="Inicializar contadores"
    onSubmit={(file) => PythonService.initializeCounters(file)}
  />
);

export default InitializeCounters;
